exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addServitudeModal .v--modal-box.v--modal{min-height:410px!important;min-width:460px!important}#addServitudeModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#addServitudeModal .v-tabs__div:not(:last-child){padding-right:5px}#addServitudeModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33ee1b26","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/servitude/modals/AddServitudeModal.vue
// module id = 1909
// module chunks = 0